<div class="search-results">
  <div class="search-results__title">
    <div class="search-results__title--wrapper">
      <div class="image-wrapper">
        <img src="../../../../../assets/images/icons/{{ titleIcon }}.svg" />
      </div>
      <h3>{{ titleUI }}</h3>
      <span data-testid="global-search-total-result">{{ numberOfResultsUI }}</span>
    </div>
    @if (total > 0) {
      <a
        class="search-results__title--browse"
        ngClass="{{ hasNoModulePermission ? 'search-results__title--browse-disabled' : '' }}"
        (click)="!hasNoModulePermission && onBrowseClicked()"
        (keydown.enter)="!hasNoModulePermission && onBrowseClicked()"
        tabindex="0"
      >
        Browse {{ browseTitleUI }}
      </a>
    }
  </div>
  @if (hasNoModulePermission) {
    <div class="search-results__no-display--found-fields">
      Multiple matches found on
      <span>{{ foundFilterTypesUI }}</span>
    </div>
    <div class="search-results__no-display" data-testid="global-search-result-no-display">
      <img src="../../../../../../../assets/images/icons/empty-state_no-view-access.svg" />
      <div class="search-results__no-display--text">
        Results not displayed, because you don’t have access to this module
      </div>
    </div>
  } @else {
    @if (total > 0) {
      <div class="search-results__items">
        @for (item of resultsUI; track item.resultText) {
          <button
            class="result__wrapper"
            tabindex="0"
            data-testid="result-wrapper"
            (keydown.enter)="onResultClicked(item)"
          >
            <app-search-result
              [item]="item"
              [serviceAddon]="serviceAddon"
              (onResultClickedEmitter)="onResultClicked($event)"
            ></app-search-result>
          </button>
        }
      </div>
    }
  }
</div>
